import { Container } from './Container';

export const SiteFooter = () => (
  <footer className="border-t border-white/5 bg-base-100">
    <Container className="py-12">
      <div className="grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="text-lg font-semibold tracking-wide">Kweebec World</div>
          <p className="mt-3 text-sm leading-relaxed text-base-content/70">
            A hardcore survival server built for raids, firearms, and long-term progression. Custom crafting and an
            in-house anti-cheat keep fights fair.
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 md:col-span-7 md:grid-cols-3">
          <div>
            <div className="text-sm font-semibold">Server</div>
            <div className="mt-3 grid gap-2 text-sm text-base-content/70">
              <a href="#world" className="transition hover:text-base-content">
                World map
              </a>
              <a href="#players" className="transition hover:text-base-content">
                Players
              </a>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold">Community</div>
            <div className="mt-3 grid gap-2 text-sm text-base-content/70">
              <a href="#faq" className="transition hover:text-base-content">
                FAQ
              </a>
              <a href="#join" className="transition hover:text-base-content">
                How to join
              </a>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold">Legal</div>
            <div className="mt-3 grid gap-2 text-sm text-base-content/70">
              <a href="#rules" className="transition hover:text-base-content">
                Rules
              </a>
              <a href="#privacy" className="transition hover:text-base-content">
                Privacy
              </a>
              <a href="#terms" className="transition hover:text-base-content">
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10 flex flex-col gap-2 border-t border-white/5 pt-6 text-xs text-base-content/60 sm:flex-row sm:items-center sm:justify-between">
        <div>© {new Date().getFullYear()} Kweebec World</div>
        <div>Not affiliated with Hypixel Studios.</div>
      </div>
    </Container>
  </footer>
);
